/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type EmploymentStatusEnum =
  (typeof EmploymentStatusEnum)[keyof typeof EmploymentStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmploymentStatusEnum = {
  Employed: 0,
  Dismissed: 100,
  LeaveOfAbsence: 200,
} as const;
